import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { Popover, PopoverBody, PopoverHeader, Button, FormGroup, Label, Input, Progress, Form, Alert, FormText, Row, Col } from 'reactstrap'
import Select from 'react-select'
import moment from "moment"
import toTitleCase from "../../Functions/toTitleCase"

import withApolloClient from '../../withApolloClient'
import { TIMEZONES } from "../../Constants"


const BranchSettingKeyQuery = gql`query AllBranchSettingKeys{
    allBranchSettingKeys {
      edges {
        node {
          id
          name
          description
          type
          isRequired
        }
      }
    }
}`

const UpdateCreateBranchSettingsMutation = gql`mutation UpdateCreateBranchSettingsMutation($input: UpdateCreateBranchSettingsMutationInput!){
    updateOrCreateBranchSetting(input:$input){
        ok
        errors{
            field
            messages
        }
    }
} `

class CreateUpdateSetting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            input: { branchId: this.props.branchId },
            loading: false
        }
    }

    handleChange = (e) => {
        let { input } = this.state
        if (e && e.target) {
            input[e.target.name] = e.target.value
            if (e.target.name === "keyId") {
                input["value"] = null
            }
        } else if (e && typeof e === "object" && e.value !== undefined && e.name) {
            input[e.name] = e.value
            if (e.name === "keyId") {
                input["value"] = null
            }
        }
        this.setState({ input })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.setState({ loading: true })
        this.props.apolloClient.mutate({
            mutation: UpdateCreateBranchSettingsMutation,
            variables: {
                input: { ...this.state.input }
            }
        }).then(({ data }) => {
            this.setState({ loading: false })
            if (data.updateOrCreateBranchSetting.ok) {
                this.setState({ input: {} })
                this.props.refetchQuery()
                this.props.handleClose()
            } else if (data.updateOrCreateBranchSetting && data.updateOrCreateBranchSetting.errors) {
                this.setState({ loading: false, error: String(data.updateOrCreateBranchSetting.errors[0].messages) })
            } else {
                this.setState({ loading: false, error: "An error has occurred. Please check your input or contact admin." })
            }
        }).catch((error) => {
            this.setState({ loading: false, error: "An error has occurred. Please contact admin." })
        })
    }


    render() {
        const selectedKey = this.state.input && this.state.input.keyId ? this.props.allBranchSettingKeys?.edges?.find(({ node }) => node.id === this.state.input.keyId)?.node : null;
        const keyOptions = this.props.allBranchSettingKeys?.edges?.map(({ node }) => ({
            value: node.id,
            label: `${toTitleCase(node.name)}${node.isRequired ? " *" : ""}`,
            description: node.description,
            type: node.type,
            name: node.name,
        })) || [];
        const booleanOptions = [{ value: "true", label: "True" }, { value: "false", label: "False" }];
        const timezoneOptions = TIMEZONES.map(zone => ({
            value: zone.value,
            label: `${moment.tz(zone.value).format('zz')} | ${zone.label}`
        }));

        return (
            <Popover placement="auto" isOpen={this.props.open} target={this.props.target} toggle={this.props.handleClose} className="branch-setting-popover" trigger="legacy">
                <PopoverHeader className="d-flex justify-content-between align-items-center">Create/Update Branch Settings</PopoverHeader>
                <PopoverBody>
                    {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                    <Form>
                        <FormGroup>
                            <Label for="keyId" className="font-weight-bold">Key</Label>
                            <Select
                                inputId="keyId"
                                name="keyId"
                                options={keyOptions}
                                value={keyOptions.find(opt => opt.value === this.state.input.keyId) || null}
                                onChange={opt => this.handleChange({ target: { name: "keyId", value: opt ? opt.value : "" } })}
                                placeholder="Select Key"
                                className="mb-2"
                                isClearable
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="value" className="font-weight-bold">Value</Label>
                            <div>
                                {selectedKey ?
                                    selectedKey.type !== "BOOLEAN" && selectedKey.name !== "PREFERRED_TIMEZONE" ?
                                        <Input
                                            type={selectedKey.type === "STRING" ? "text" : "number"}
                                            name="value"
                                            id="value"
                                            onChange={this.handleChange}
                                            style={{ borderRadius: "6px" }}
                                            className="mb-2"
                                        /> :
                                        selectedKey.name === "PREFERRED_TIMEZONE" ?
                                            <Select
                                                inputId="value"
                                                name="value"
                                                options={timezoneOptions}
                                                value={timezoneOptions.find(opt => opt.value === this.state.input.value) || null}
                                                onChange={opt => this.handleChange({ target: { name: "value", value: opt ? opt.value : "" } })}
                                                placeholder="Select Timezone"
                                                className="mb-2"
                                                isClearable
                                            /> :
                                            <Select
                                                inputId="value"
                                                name="value"
                                                options={booleanOptions}
                                                value={booleanOptions.find(opt => opt.value === this.state.input.value) || null}
                                                onChange={opt => this.handleChange({ target: { name: "value", value: opt ? opt.value : "" } })}
                                                placeholder="Select Option"
                                                className="mb-2"
                                                isClearable
                                            />
                                    :
                                    <Input type="text" name="value" id="value" disabled className="mb-2" />
                                }
                                <FormText className="text-muted">{selectedKey?.description}</FormText>
                            </div>
                        </FormGroup>
                        <Row className="mt-3">
                            <Col xs="12" className="text-right">
                                {this.state.loading
                                    ? <Progress animated color="info" value={100} />
                                    : <Button type="submit" color="primary" onClick={this.handleSubmit} style={{ borderRadius: "6px", minWidth: "100px" }}>Submit</Button>
                                }
                            </Col>
                        </Row>
                    </Form>
                </PopoverBody>
            </Popover>
        )
    }
}

export default graphql(BranchSettingKeyQuery, {
    props: ({ data: { allBranchSettingKeys } }) => ({
        allBranchSettingKeys
    })
})(withApolloClient(CreateUpdateSetting))
